module.exports = __webpack_public_path__ + "res/34-img_game_bg.8c83aabbdef15a98f8441f3fda49a988.png";